import { defineStore } from 'pinia'
import SyncZaloService from "@/services/sync-zalo.service.js";
export const useSyncZalo = defineStore('useSyncZalo', {
    state: () => {
        return {
            datas: [],
            usersZalo: [],
            paginate: {},
            codeChallenge: '',
            codeVerifier: '',
            syncZalo: {},
            messagesZalo: [],
            isLoading: false
        }
    },
    persist: true,
    actions: {
        async getCodeVerifier(url, params) {
            try {
                const res = await SyncZaloService.getCodeVerifier(url, params)
                this.codeVerifier = res.data.data.code_verifier
                this.codeChallenge = res.data.data.code_challenge
            } catch (e) {
                return null
            }
        },
        async getSyncZalo(url, params) {
            try {
                const res = await SyncZaloService.getSyncZalo(url, params)
                this.syncZalo = res.data.data
            } catch (e) {
                return null
            }
        },
        async authenticateDomain(url, params) {
            try {
                const res = await SyncZaloService.authenticateDomain(url, params)
                // this.codeChallenge = res.data
                return res.data
            } catch (e) {
                return e
            }
        },
        async callbackZalo(url, params) {
            try {
                const res = await SyncZaloService.callbackZalo(url, params)
                return res.data
            } catch (e) {
                return e
            }
        },
        async checkURLCallback(url, params) {
            try {
                const res = await SyncZaloService.checkURLCallback(url, params)
                return res.data
            } catch (e) {
                return e
            }
        },
        async storeSettingConnectZalo(url, params) {
            try {
                const res = await SyncZaloService.storeSettingConnectZalo(url, params)
                return res.data
            } catch (e) {
                return e
            }
        },
        async syncListFollowers(url, params) {
            try {
                this.isLoading = true
                const res = await SyncZaloService.syncListFollowers(url, params)
                return res.data
            } catch (e) {
                return e
            } finally {
                this.isLoading = false
            }
        },
        async sendInviteCooperate(url, params) {
            try {
                const res = await SyncZaloService.sendInviteCooperate(url, params)
                return res.data
            } catch (e) {
                return e
            }
        },
        async getListMessages(url, params) {
            try {
                const res = await SyncZaloService.getListMessages(url, params)
                this.messagesZalo = res.data.data
                this.paginate = res.data.meta
            } catch (e) {
                return e
            }
        },
        async getListUsersZalo(url, params) {
            try {
                const res = await SyncZaloService.getListUsersZalo(url, params)
                this.usersZalo = res.data.data
                this.paginate = res.data.meta
            } catch (e) {
                return e
            }
        },

    }
})